import { render } from "./ClosingButton.vue?vue&type=template&id=0b5a8df1&scoped=true"
import script from "./ClosingButton.vue?vue&type=script&lang=js"
export * from "./ClosingButton.vue?vue&type=script&lang=js"

import "./ClosingButton.vue?vue&type=style&index=0&id=0b5a8df1&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5a8df1"]])

export default __exports__